import { useCallback, useEffect, useState } from 'react';
import { ApiError } from '@/api/client';
import { fetchMyLimosa, type MyLimosa } from '@/api/administratie';

/**
 * The login's people and their Limosa status on `date` (the planning day). Only
 * fetched when `enabled`: Limosa is for onderaannemers. A reload after an upload
 * keeps the current answer on screen; another day never shows the previous one.
 */
export function useMyLimosa(date: string, enabled: boolean) {
  const [result, setResult] = useState<{ date: string; data: MyLimosa | null; error: string | null } | null>(null);
  const [version, setVersion] = useState(0);

  useEffect(() => {
    if (!enabled) return;
    let cancelled = false;
    fetchMyLimosa(date)
      .then((data) => { if (!cancelled) setResult({ date, data, error: null }); })
      .catch((err) => {
        if (!cancelled) setResult({ date, data: null, error: err instanceof ApiError && err.message ? err.message : 'Limosa ophalen mislukt' });
      });
    return () => { cancelled = true; };
  }, [date, enabled, version]);

  const reload = useCallback(() => setVersion((v) => v + 1), []);
  const current = enabled && result?.date === date ? result : null;
  return { data: current?.data ?? null, error: current?.error ?? null, reload };
}
